import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {OptionsBlock as Component} from './OptionsBlock';
import {Utilities} from '@learningblocks/exp-constants';

const {DESIGN_SLIDE_TYPES, SLIDE_NODE} = Utilities;

function mapStateToProps(state) {
  return getOptionsBlockPorps(state);
}

function mapDispatchToProps(dispatch) {
  return {
    setAsNextStep: (params) => {
      // dispatch(setAsNextStep(params));
    },
  };
}

const OptionsBlock = connect(mapStateToProps, mapDispatchToProps)(Component);

export {OptionsBlock as OptionsBlockWithRedux, Component as OptionsBlock};

const getDesignSection = ({notebook}) => notebook.designSection;

const getOptionsBlockPorps = createSelector(
  [getDesignSection],
  (designSection) => {
    let currentDesignSection = designSection.allSlides.find(
      (slide) => slide.type === designSection.currentSlide
    );

    if (currentDesignSection.type === DESIGN_SLIDE_TYPES.ONE) {
      let {incorrects, maxIncorrects, optionsTitle} = currentDesignSection;
      let optionsList = getSlideOneOptions(currentDesignSection);
      return {
        incorrects,
        maxIncorrects,
        optionsList,
        optionsTitle,
        type: currentDesignSection.type,
      };
    }

    if (currentDesignSection.type === DESIGN_SLIDE_TYPES.THREE) {
      let {incorrects, maxIncorrects, optionsTitle} = currentDesignSection;
      let optionsList = getSlideThreeOptions(currentDesignSection);
      return {
        incorrects,
        maxIncorrects,
        optionsTitle,
        optionsList,
        type: currentDesignSection.type,
      };
    }
    if (currentDesignSection.type === DESIGN_SLIDE_TYPES.TWO) {
      let {incorrects, maxIncorrects} = currentDesignSection;
      let currentNode = getCurrentNode(currentDesignSection.slideTree);
      let {
        nodeOptionsDescription: optionsDescription,
        nodeOptionsTitle: optionsTitle,
      } = currentNode;
      let optionsList = [];
      if (currentNode.nodeType != SLIDE_NODE.JOINT_PATH_SELECT) {
        optionsList = getCurrentSlideTwoOptions(currentNode);
      }
      return {
        incorrects,
        maxIncorrects,
        optionsTitle,
        optionsDescription,
        optionsList,
        type: currentDesignSection.type,
      };
    }
  }
);

function getSlideOneOptions(designSlideOne) {
  let allOptions = designSlideOne.options;
  let allDroppedOptions = designSlideOne.slideTree.map(
    (node) => node.droppedId
  );
  return allOptions.filter((option) => !allDroppedOptions.includes(option.id));
}

function getSlideThreeOptions(designSlideThree) {
  let allOptions = designSlideThree.options;
  let allDroppedOptions = designSlideThree.slideTree.reduce(
    (droppedOptions, group) => {
      for (let node of group.groupNodes) {
        if (node.droppedId !== null) {
          droppedOptions.push(node.droppedId);
        }
      }
      return droppedOptions;
    },
    []
  );
  return allOptions.filter((option) => !allDroppedOptions.includes(option.id));
}

function getCurrentNode(slideTree) {
  for (let group of slideTree) {
    for (let node of group.groupNodes) {
      if (node.current) {
        return node;
      }
    }
  }
}

function getCurrentSlideTwoOptions(currentNode) {
  let allOptions = currentNode.nodeOptions;
  let droppedOptions = getDroppedItemsInCurentNode(currentNode.nodeComponents);
  return allOptions.filter((option) => !droppedOptions.includes(option.id));
}

function getDroppedItemsInCurentNode(nodeComponents) {
  return nodeComponents.reduce((list, component) => {
    if (component.droppedId != null) {
      list.push(component.droppedId);
    }
    return list;
  }, []);
}
